import { useState } from "react";

export const useFilters = (params) => {
  const [filters, setFilters] = useState(params);
  return [filters, setFilters];
};
